App.factory('Message', ['restmod', restmod => restmod.model('/messages')])